import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_MODEL_VARIANT = gql `
  mutation UpdateWarehouseReleaseModelVariant($variantsQuantity: [[ID]]!) {
    updateWarehouseReleaseModelVariant(variantsQuantity: $variantsQuantity) {
      warehouseReleaseModelVariant {
        id
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_MODEL_VARIANT;
